const zoneApplicants = {
  assignApplicants: "تحديد مقدم الطلب",
  assignSupervisor: "تحديد مشرف",
  changeSupervisor: "تغيير المشرف",
  supervisor: "المشرف",
  applicants: "المتقدمين",
  search: "ابحث بالاسم أو الرقم",
  staffApplicant: "الموظف / المتقدم",
  rating: "التقييم",
  action: "الإجراء",
  unassign: "إلغاء التعيين",
  applicantsRole: "وظيفة المتقدم",
  allRoles: "كل الوظائف",
  /** {count} = how many applicants are ticked in the assign modal */
  selectedCount: "{count} محدد",
  /** {role} = the role the applicant applied with */
  applicantRole: "الوظيفة: {role}",
  assignSelected: "تعيين المحدد",
  changeRole: "تغيير الوظيفة",
  showingRange: "عرض {from}-{to} من أصل {total} متقدم",
  unassignModal: {
    title: "تأكيد إلغاء التعيين",
    unassignConfirmationMsg:
      "هل أنت متأكد أنك تريد إلغاء تعيين هذا المتقدم من منطقته؟",
    zoneWillBeCleared: "سيتم مسح المنطقة",
    statusChange: "حالة التعيين: معين ← غير معين",
    /** {count} = how many applicants were unassigned */
    successTitle: "تم إلغاء تعيين {count} متقدمين من المنطقة بنجاح.",
    successTitleSingle: "تم إلغاء تعيين متقدم واحد من المنطقة بنجاح.",
    successZoneCleared: "تم تحديث المنطقة إلى غير معينة",
  },
  unassignSupervisor: "إلغاء تعيين المشرف",
  unassignSupervisorModal: {
    title: "تأكيد إلغاء التعيين",
    confirmationMsg: "هل أنت متأكد أنك تريد إلغاء تعيين هذا المشرف من منطقته؟",
    warningTitle: "لن يكون للمنطقة مشرف",
    warningDescription: "سيظل المتقدمون المعينون في هذه المنطقة كما هم.",
    success: "تم إلغاء تعيين المشرف من المنطقة بنجاح.",
  },
  assignModal: {
    title: "تعيين متقدمي المنطقة",
    /** {count} = how many applicants were assigned */
    successTitle: "تم تعيين {count} متقدمين في المنطقة بنجاح.",
    successTitleSingle: "تم تعيين متقدم واحد في المنطقة بنجاح.",
  },
  supervisorModal: {
    assignTitle: "تحديد مشرف",
    changeAndSave: "تغيير وحفظ",
    replacing: "استبدال",
    noAvailableSupervisor: "لا يوجد مشرف متاح",
    assignSuccess: "تم تعيين المشرف في المنطقة بنجاح.",
  },
  emptyState: {
    title: "لا يوجد متقدمين في هذه المنطقة",
    description: "قم بتعيين المتقدمين المقبولين للبدء في تجهيز هذه المنطقة.",
  },
  allAssigned: {
    title: "تم تعيين جميع المتقدمين بالفعل",
    /** {role} = the selected role filter */
    description:
      "جميع المتقدمين ضمن {role} في هذه الفعالية تم تعيينهم في مناطق بالفعل. غيّر عامل تصفية الوظيفة أو راجع قائمة متقدمي المنطقة.",
  },
  filteredEmptyState: {
    title: "لا يوجد متقدمين مطابقين",
    description: "جرب كلمة بحث مختلفة أو قم بمسح عوامل التصفية.",
  },
  notAssigned: "لم يتم التعيين بعد",
};

export default zoneApplicants;
